export default __webpack_public_path__ + "static/media/image.f401bd3c.png";